import React from 'react';
import { COLORS, FONT } from './tokens';

/*
 * TotalsBar — the summary line under a report section ("BALANCE B/F … NET BALANCE …").
 * A tinted, right-aligned box; the label/value spans inside are the caller's own, unchanged.
 * Replaces the dashed rule with the totals floating on it.
 * On a phone (pc-totals-bar in mobile.css) each label / value pair takes its own line and the
 * empty separator spans are hidden; the children are unchanged.
 */
export default function TotalsBar({ children, style }) {
    return (
        <div className="pc-totals-bar" style={{
            display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 4,
            margin: '16px 0 8px', padding: '10px 16px', borderRadius: 8,
            background: COLORS.surfaceAlt, border: `1px solid ${COLORS.border}`,
            fontFamily: FONT, fontSize: 14, color: COLORS.text, ...style,
        }}>
            {children}
        </div>
    );
}
